import { availableLanguages } from '../constants/language';

export const getInitialLanguage = () => {
  const localStorageLanguage = localStorage.getItem('language');

  // Language is found in local storage & it is in our avaliable languages
  if (localStorageLanguage) {
    if (availableLanguages.includes(localStorageLanguage)) {
      return localStorageLanguage;
    }
  }

  const browserLanguage = (window as any).navigator.userLanguage || window.navigator.language;

  // Attempt to get default browser language & check if it is in our available languages
  if (typeof browserLanguage === 'string') {
    if (availableLanguages.includes(browserLanguage)) {
      return browserLanguage;
    }
  }

  // If everything above fails - return english
  return 'en-US';
};
